import React from "react";
import History2 from "components/comp/History2";

// why: 회사 연혁을 독립 페이지로 구성하여 연대기 탐색에 최적화

const AboutHistory = () => {
  return (
    <main className="page-sub">
      <section className="company-main">
        <History2/>
      </section>
    </main>
  );
};

export default AboutHistory;


